/* globals jQuery, google */
(($) => {
    //mobile back to map button - hide list, open map
    $('.js-map-back').on('click',function(){
        $('.section-map__list').removeClass('open');
        $('.section-map__map').addClass('open');
    });
    
    /* SETUP COMMUNITY MAP */
    var map = document.getElementById('community-map');
    if( map ){
        var CommunityMapClass = require('./communities-map.js');
        var communityMap = new CommunityMapClass(map);
        communityMap.initMap(true);
    }

})(jQuery)